import { action, makeObservable, observable } from 'mobx';

class IntroBarStore {
  isSwitcherOn = true;

  constructor() {
    makeObservable(this, {
      isSwitcherOn: observable,
      switcherToggle: action.bound,
    });
  }

  switcherToggle(boolValue) {
    if (boolValue !== undefined) {
      this.isSwitcherOn = boolValue;
    }
    this.isSwitcherOn = !this.isSwitcherOn;
  }
}

export const introBarStore = new IntroBarStore();
